/**
 * Strength and domain-related constants
 */

// All CliftonStrengths
export const ALL_STRENGTHS = [
  // Executing Domain
  "Achiever", "Arranger", "Belief", "Consistency", "Deliberative", 
  "Discipline", "Focus", "Responsibility", "Restorative",
  // Influencing Domain
  "Activator", "Command", "Communication", "Competition", 
  "Maximizer", "Self-Assurance", "Significance", "Woo",
  // Relationship Building Domain
  "Adaptability", "Connectedness", "Developer", "Empathy", 
  "Harmony", "Includer", "Individualization", "Positivity", "Relator",
  // Strategic Thinking Domain
  "Analytical", "Context", "Futuristic", "Ideation", 
  "Input", "Intellection", "Learner", "Strategic"
] as const;

// Domain configuration
export const DOMAINS = [
  { name: 'Executing', color: 'bg-secondary' },
  { name: 'Influencing', color: 'bg-warning' },
  { name: 'Relationship Building', color: 'bg-brand-teal-dark' },
  { name: 'Strategic Thinking', color: 'bg-primary' }
] as const;

// Domain color mapping
export const DOMAIN_COLORS: Record<string, string> = {
  "Strategic Thinking": "bg-primary",
  "Executing": "bg-secondary",
  "Influencing": "bg-warning",
  "Relationship Building": "bg-brand-teal-dark"
};

// Domain text color mapping (for badges)
export const DOMAIN_TEXT_COLORS: Record<string, string> = {
  "Strategic Thinking": "bg-primary/10 text-primary border border-primary/20",
  "Executing": "bg-secondary/10 text-brand-green-dark border border-secondary/25",
  "Influencing": "bg-warning/10 text-warning border border-warning/25",
  "Relationship Building": "bg-brand-teal-dark/10 text-brand-teal-dark border border-brand-teal-dark/25"
};

// Fixed hex color mapping used specifically by the Strengths Explorer feature
// (Theme Library, Leaderboards, and full profile drill-down) as badges/accents.
export const STRENGTHS_EXPLORER_DOMAIN_COLORS: Record<string, string> = {
  "Executing": "#7B2481",
  "Influencing": "#E97200",
  "Relationship Building": "#0070CD",
  "Strategic Thinking": "#00A47F"
};


// Strength to domain mapping
export const STRENGTH_DOMAIN_MAP: Record<string, string> = {
  // Executing
  "Achiever": "Executing",
  "Arranger": "Executing",
  "Belief": "Executing",
  "Consistency": "Executing",
  "Deliberative": "Executing",
  "Discipline": "Executing",
  "Focus": "Executing",
  "Responsibility": "Executing",
  "Restorative": "Executing",
  // Influencing
  "Activator": "Influencing",
  "Command": "Influencing",
  "Communication": "Influencing",
  "Competition": "Influencing",
  "Maximizer": "Influencing",
  "Self-Assurance": "Influencing",
  "Significance": "Influencing",
  "Woo": "Influencing",
  // Relationship Building
  "Adaptability": "Relationship Building",
  "Connectedness": "Relationship Building",
  "Developer": "Relationship Building",
  "Empathy": "Relationship Building",
  "Harmony": "Relationship Building",
  "Includer": "Relationship Building",
  "Individualization": "Relationship Building",
  "Positivity": "Relationship Building",
  "Relator": "Relationship Building",
  // Strategic Thinking
  "Analytical": "Strategic Thinking",
  "Context": "Strategic Thinking",
  "Futuristic": "Strategic Thinking",
  "Ideation": "Strategic Thinking",
  "Input": "Strategic Thinking",
  "Intellection": "Strategic Thinking",
  "Learner": "Strategic Thinking",
  "Strategic": "Strategic Thinking"
};
